import { dialogsListApi } from '@shared/api/dialogs-list-api';
import { generatedApi } from '@shared/api/generated-api';
import type { RootState } from '@shared/redux';

export const clientInfoEndpoints = {
  getClientFieldsClientFieldsGet: {},

  resendLeadClientLeadResendPost: {
    invalidatesTags: [],
  },

  updateClientTestClientUpdateTestPost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      const { client_id, is_test } = arg.updateClientTestData;
      const cachedArgs = dialogsListApi.util.selectCachedArgsForQuery(
        getState() as RootState,
        'getListDialogsDialogListPostQuery',
      );

      const patchResults = cachedArgs.map((queryArgs) =>
        dispatch(
          dialogsListApi.util.updateQueryData(
            'getListDialogsDialogListPostQuery',
            queryArgs,
            (draft) => {
              const dialog = draft.items?.find((item) => item.client_id === client_id);
              if (dialog) dialog.is_test = is_test;
            },
          ),
        ),
      );

      try {
        await queryFulfilled;
      } catch {
        patchResults.forEach((patch) => patch.undo());
      }
    },
  },

  updateClientFieldsClientFieldsUpdatePost: {
    invalidatesTags: [],
    async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
      const { client_id, agent_field_id, value } = arg.updateClientFieldData;

      const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
        getState() as RootState,
        'getClientFieldsClientFieldsGet',
      );

      const patchResults: Array<{ undo: () => void }> = [];

      for (const queryArgs of cachedArgs) {
        if ((queryArgs as any)?.clientId !== client_id) continue;

        const patch = dispatch(
          generatedApi.util.updateQueryData(
            'getClientFieldsClientFieldsGet',
            queryArgs as any,
            (draft) => {
              const draftAgents = draft as Array<{
                client_fields?: Array<{ agent_field_id: number; value: string }>;
              }>;

              for (const agent of draftAgents) {
                const field = agent.client_fields?.find((f) => f.agent_field_id === agent_field_id);
                if (field) {
                  field.value = value;
                  break;
                }
              }
            },
          ),
        );

        patchResults.push(patch);
      }

      try {
        await queryFulfilled;
      } catch {
        patchResults.forEach((p) => p.undo());
      }
    },
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
